export default __webpack_public_path__ + "static/media/store-install.a35e4ad9.webp";